<template>
  <transition name="fade-slide" mode="in-out">
    <div v-show="index===current_slide" class="CarouselSlide">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  props:{
    current_slide:{
      type: Number,
      required: true
    },
    index:{
      type: Number,
      required: true
    }
  },
  name: "CarouselSlide"
}
</script>

<style scoped>
.CarouselSlide{
  position: absolute;
  width: 100%;
  height: 100%;
}
.fade-slide-enter-active{
  animation: slideInAnimation 1s ease-in-out;
}
.fade-slide-leave-active{
  animation: slideOutAnimation 1s ease-in-out;
}
@keyframes slideInAnimation {
  from {transform: translateX(100%)}
  to {transform: translateX(0)}
}
@keyframes slideOutAnimation {
  from {transform: translateX(0)}
  to {transform: translateX(-100%)}
}
</style>